<template>
  <div class="coupon-issued-page">
    <Card>
      <div class="page-toolbar">
        <Button icon="ios-arrow-back" @click="goBack">返回优惠券管理</Button>
      </div>
      <Form :label-width="90" inline class="issued-search">
        <FormItem label="客户ID">
          <Input v-model="query.customer_id" placeholder="客户 Mongo ID" clearable style="width: 220px" />
        </FormItem>
        <FormItem label="模板ID">
          <Input v-model="query.template_id" placeholder="券模板 ID" clearable style="width: 220px" />
        </FormItem>
        <FormItem label="状态">
          <Select v-model="query.status" clearable placeholder="全部" style="width: 120px">
            <Option value="">全部</Option>
            <Option value="unused">未使用</Option>
            <Option value="expired">已过期</Option>
            <Option value="used">已使用</Option>
            <Option value="revoked">已销毁</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="20">
          <Button type="primary" @click="search">查询</Button>
          <Button class="m-l-10" @click="resetQuery">重置</Button>
          <Button class="m-l-10" @click="load">刷新</Button>
        </FormItem>
      </Form>
      <Table class="m-t-16" :loading="loading" :columns="columns" :data="list" border stripe />
      <Page
        v-show="total > 0"
        class="issued-page"
        :total="total"
        :current="query.page"
        :page-size="query.pageSize"
        :page-size-opts="[10, 20, 50]"
        show-sizer
        show-elevator
        show-total
        @on-change="onPageChange"
        @on-page-size-change="onPageSizeChange"
      />
    </Card>
  </div>
</template>


<script>
import { couponUserCouponList, couponUserCouponRevoke } from '@/api/coupon'

export default {
  name: 'CouponIssued',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        customer_id: '',
        template_id: '',
        status: '',
        page: 1,
        pageSize: 20,
      },
      columns: [
        {
          title: '券ID',
          minWidth: 200,
          ellipsis: true,
          tooltip: true,
          render: (h, { row }) => h('span', this.formatId(row._id)),
        },
        {
          title: '客户ID',
          minWidth: 200,
          ellipsis: true,
          tooltip: true,
          render: (h, { row }) => h('span', row.cus_user_id || '-'),
        },
        {
          title: '用户',
          minWidth: 120,
          render: (h, { row }) =>
            h('span', row.customer_nickname || row.customer_phone || '-'),
        },
        {
          title: '模板ID',
          minWidth: 200,
          ellipsis: true,
          tooltip: true,
          render: (h, { row }) => h('span', this.formatId(row.template_id)),
        },
        { title: '券名', key: 'template_name', minWidth: 120 },
        {
          title: '类型',
          width: 72,
          render: (h) => h('span', '消费'),
        },
        {
          title: '优惠',
          width: 120,
          render: (h, { row }) => h('span', this.formatIssuedDiscount(row)),
        },
        {
          title: '状态',
          width: 88,
          render: (h, { row }) => h('span', this.statusLabel(row.display_status)),
        },
        {
          title: '有效期至',
          minWidth: 150,
          render: (h, { row }) => h('span', this.formatDate(row.valid_to)),
        },
        {
          title: '渠道',
          width: 72,
          render: (h, { row }) => h('span', row.obtain_channel === 'admin' ? '后台' : '领取'),
        },
        {
          title: '操作',
          width: 88,
          fixed: 'right',
          render: (h, { row }) => {
            if (row.status !== 'unused') return h('span', '-')
            return h(
              'Button',
              {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.confirmRevoke(row) },
              },
              '销毁'
            )
          },
        },
      ],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'coupon-manage' })
    },
    formatId(id) {
      if (id == null || id === '') return ''
      if (typeof id === 'object' && id.$oid != null) return String(id.$oid)
      return String(id)
    },
    statusLabel(s) {
      const map = {
        unused: '未使用',
        expired: '已过期',
        used: '已使用',
        revoked: '已销毁',
      }
      return map[s] || s || '-'
    },
    formatDate(v) {
      if (!v) return '-'
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return '-'
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    formatIssuedDiscount(row) {
      if (!row) return '—'
      if (row.coupon_kind === 'discount' && row.discount_pay_percent != null) {
        const p = Number(row.discount_pay_percent)
        if (!Number.isFinite(p) || p <= 0 || p >= 100) return '折扣'
        const z = Math.round((p / 10) * 10) / 10
        return `约${z}折（实付${p}%）`
      }
      return row.discount_fen != null ? `${row.discount_fen} 分` : '—'
    },
    resetQuery() {
      this.query = {
        customer_id: '',
        template_id: '',
        status: '',
        page: 1,
        pageSize: 20,
      }
      this.load()
    },
    search() {
      this.query.page = 1
      this.load()
    },
    onPageChange(page) {
      this.query.page = page
      this.load()
    },
    onPageSizeChange(size) {
      this.query.pageSize = size
      this.query.page = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const params = {
          page: this.query.page,
          pageSize: this.query.pageSize,
        }
        if (this.query.customer_id) params.customer_id = this.query.customer_id.trim()
        if (this.query.template_id) params.template_id = this.query.template_id.trim()
        if (this.query.status) params.status = this.query.status
        const res = await couponUserCouponList(params)
        if (res.data.code === 200) {
          const data = res.data.data || {}
          this.list = data.list || []
          this.total = data.total || 0
        } else {
          this.$Message.error(res.data.msg || '加载失败')
        }
      } catch (e) {
        this.$Message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    confirmRevoke(row) {
      const id = this.formatId(row._id)
      this.$Modal.confirm({
        title: '确认销毁',
        content: `确定销毁该优惠券？销毁后用户将无法使用。（券ID: ${id}）`,
        onOk: () => this.doRevoke(row),
      })
    },
    async doRevoke(row) {
      const id = this.formatId(row._id)
      try {
        const res = await couponUserCouponRevoke(id)
        if (res.data.code === 200) {
          this.$Message.success('已销毁')
          this.load()
        } else {
          this.$Message.error(res.data.msg || '销毁失败')
        }
      } catch (e) {
        this.$Message.error('销毁失败')
      }
    },
  },
}
</script>

<style scoped>
.page-toolbar {
  margin-bottom: 16px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-t-16 {
  margin-top: 16px;
}
.issued-page {
  margin-top: 16px;
  text-align: right;
}
</style>
